import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=36dd7214&scoped=true&"
import script from "./CollegeList.vue?vue&type=script&lang=js&"
export * from "./CollegeList.vue?vue&type=script&lang=js&"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=36dd7214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd7214",
  null
  
)

export default component.exports